import type { RiskBand } from "./contracts";

export const CAYLET_RISK_THRESHOLDS = Object.freeze({ lowMax: 20, mediumMax: 69 });

export function mapScoreToRiskBand(score: number | undefined): RiskBand {
  if (score === undefined || !Number.isFinite(score) || score < 0 || score > 100) return "unknown";
  if (score <= CAYLET_RISK_THRESHOLDS.lowMax) return "low";
  if (score <= CAYLET_RISK_THRESHOLDS.mediumMax) return "medium";
  return "high";
}

export function mapProviderRisk(value: unknown, score?: number): RiskBand {
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (normalized === "low") return "low";
    if (normalized === "medium") return "medium";
    if (normalized === "high" || normalized === "very high") return "high";
  }
  return mapScoreToRiskBand(score);
}
